 <app-dialog-base [Title]='"Key/Label"|translate' [dialogId]="dialogId" (onClose)="close()" (onSubmit)="submit()">
  <div class="btn_tabs">
    <button (click)="openTab('main')" [class.active]="openedTabName == 'main'">{{"Main"|translate}}</button>
  </div>
  <div class="horseparator"></div>
  <div id="main" *ngIf="isSelected('main')" class="tablewrap">
    <div class="inputgroup">
      <label>{{'Name'|translate}}</label>
      <input type="text" placeholder="{{'Name'|translate }}" [(ngModel)]="model.Name" />
    </div>
    <div class="inputgroup">
      <label>{{'Description'|translate}}</label>
      <input type="text" placeholder="{{'Description'|translate }}" [(ngModel)]="model.Comment" />
    </div>
    <div class="inputgroup" *ngIf="containers.length || creatableContainers.length">
      <label>{{'Container'|translate}}</label>
      <input *ngIf="isEditMode" type="text" [value]="getSelectedContainerName()" readonly />
      <select *ngIf="!isEditMode" [(ngModel)]="model.ContainerId">
        <option *ngFor="let container of creatableContainers" [ngValue]="container.Id">{{container.Name}}</option>
      </select>
    </div>
    <div class="inputgroup">
      <label>{{'Code'|translate}}</label>
      <input type="text" [(ngModel)]="model.UID"/>
    </div>
    <div class="inputgroup">
      <label>{{'Type'|translate}}</label>
      <select title="{{'Type'|translate}}" [(ngModel)]="model.Type">
        <option [selected]="model.Type == 'iButton'">{{'iButton'|translate}}</option>
        <option [selected]="model.Type == 'RFID'">{{'RFID'|translate}}</option>
        <option [selected]="model.Type == 'Code'">{{'Code'|translate}}</option>
      </select>
    </div>
    <div class="inputgroup">
      <label>{{'Driver'|translate}}</label>
      <input type="text" placeholder="" *ngIf="model.DriverId != undefined && model.DriverId != 0"
             [(ngModel)]="model.DriverName"
             [readOnly]="true" />
      <input type="text" placeholder="" *ngIf="model.DriverId == undefined || model.DriverId == 0" value=""
             [readOnly]="true" />
      <div>
        <button class="btnlink" (click)="selectDriver()">{{ 'Select' | translate }}</button>
        <button class="btnlink" *ngIf="model.DriverId != undefined && model.DriverId != 0" (click)="clearDriver()">{{'Clear'|translate }}</button>
      </div>
    </div>

    <app-base-group-mgmt-component [Title]="'Groups'" [Objects]="model.Groups" [groups]="groups">
      <ng-template let-item>
        <td>{{item.Name}}</td>
      </ng-template>
    </app-base-group-mgmt-component>
  </div>
</app-dialog-base>
<template #objectsListDialog></template>
